<template>
  <div class="content-popup container-fluid d-block scrollbar py-2 white" :class="{'white card' : !loggedin}"
       v-if="active">
    <div class="container">

      <button class="btn btn-outline-secondary my-2 float-right" @click="hide">&times; Close</button>
      <h1>Need help?</h1>
      <hr>
      <h2>THE 4PASSWORD AUTHENTICATOR</h2>
      <p>The goal of the 4Passwords Authenticator app is to efficiently and securely use online or cached offline
        One-time Passwords (OTP&rsquo;s) that are shared and stored within a Thycotic On-premise of cloud based Secret
        Server.</p>
      <p>The 4Passwords Authenticator is a client-side app that runs exclusively in a client&rsquo;s browser and
        computer. Once the application is downloaded from either 4Passwords.com, 4pa.app or your own hosted servers,
        then the app will receive and send data through the app with the configured Thycotic Secret Server and its
        enabled web services API. The app will never send any data to any other system or website then the configured
        Secret Server within the app.</p>
      <p>The optional offline cache will be protected by a passphrase that encrypts your OTP keys inside the app or
        browser cache with 256-bit AES encryption.</p>
      <hr/>
      <h3>Application feature overview.</h3>
      <ul>
        <li>Retrieve One-time Password keys from a centrally configured Thycotic Secret Server and a predefined
          Authenticator template.
        </li>
        <li>Efficiently share and update One-time Passwords within an organization.</li>
        <li>Provide an Online and encrypted Offline cache mode.</li>
        <li>Create a preferred list of favorited One-time Passwords, separate from the native Secret Server favorited
          secret list.
        </li>
        <li>Safe and load application settings, offline passphrase and the favorites list inside a personal preference
          secret inside the configured Thycotic Secret Server.
        </li>
        <li>Administrators can prepare an Autodiscover companywide preference secret that can assist all users within a
          secret server to find the preferred Authenticator template. This can be set per domain.
        </li>
        <li>Cross platform usage on any mobile and desktop web browser that supports java script.</li>
      </ul>
      <hr/>
      <h2>What are One-time Passwords?</h2>
      <p>One-time Passwords (OTP&rsquo;s) are also known as Google , Microsoft, TOTP Authenticators, and as MFA
        (Multi-factor), 2FA (Two factor Authentication) Keys.</p>
      <p>All One-time Password techniques do in principle the same: During an authentication process the server requests
        to the client to respond with a numeric challenge. Both sides will calculate a number based on a shared key and
        the time. As the client and the server both hold the same key and if the time on the client and server are in
        sync then the client and server will generate the same number. The client can then respond correctly to the
        challenge without exposing its key on the network.</p>
      <p>The challenge with traditional OTP tools for One-time password usage, is that the keys are stored externally on
        the server and in the client. This key is mostly presented One-time to the client and are often not stored
        centrally in an Enterprise PAM solution, but saved in a third party authenticator app per person, per account on
        separated devices. These apps have also no auditing or other methods of sharing these keys. Managing these keys
        is then a lot of manual work to manage, share, store or update these keys. This complicates things and often
        results in not using a Two factor authentication at all in external accounts. While the accounts that can be
        benefit and be protected with this extra layer of security are often also high privileged accounts.
      </p>
      <p>To not use a Two factor Authentication when possible is simple not secure enough.</p>
      <hr/>
      <h2>First time usage.</h2>
      <p>Please make sure your System administrator has prepared Thycotic Secret Server for the usage of this APP. see
        the ADMIN section below for the configuration guidelines.</p>
      <p>The initial screen is the setup wizard screen. As described below, follow the Configuration wizard,
        alternatively you can switch to manual mode.</p>
      <hr/>
      <h3>Configuration wizard</h3>
      <p>When the app is loaded for the first time, it will not detect any previous settings or the offline cached mode.
      </p>
      <p>The setup wizard will guide you through the 4 main steps in configuring the app.</p>
      <ol>
        <li>Secret Server URL &amp; Authentication Domain</li>
        <ul>
          <li>Provide your full Secret Server URL.</li>
          <ul>
            <li>make sure you use HTTPS:// and the optional subfolder</li>
          </ul>
          <li>Provide your Domain Name.</li>
          <ul>
            <li>this field, should contain either your domain name as you see in the dropdown box of your secret server,
              or the word local for local account login, or empty to use the default domain listed in Secret
              Server.
            </li>
          </ul>
          <li>Press the Next step button to continue.</li>
        </ul>
        <li>User Credentials</li>
        <ul>
          <li>Provide your username</li>
          <li>Provide your password</li>
          <li>Provide your Authenticator code</li>
          <ul>
            <li>if left blank and an authenticator is required, this will count as a failed login.</li>
            <li>make sure to wait on the OTP refresh so the code is correct. you can lock your Thycotic Secret Server
              account if trying too many times, with a wrong OTP code or password.
            </li>
            <li>when login fails too many times, there can be a clock sync problem on your workstation and on the
              server. these both need to be in sync.
            </li>
          </ul>
          <li>Press the login button</li>
          <ul>
            <li>If successful, the wizard will continue to the next step.</li>
          </ul>
        </ul>
        <li>4PA Settings</li>
      </ol>
      <p>This step will search automatically for an existing user preferences secret and or any global Autodiscover
        preferences.</p>
      <p>The screen may show additional screen before the final state it found. please wait until its finished.</p>
      <p>Below you see the three possible screens the setup wizard can show.</p>
      <p>No preferences found, manual configuration required.</p>
      <p>If the app fails to find any preferences secrets then the app will ask you to supply a template ID.</p>
      <ul>
        <ul>
          <li>If requested supply the Authenticator template ID.</li>
          <li>Most likely your Thycotic Secret Server Admin did not prepare secret server with Autodiscover preference
            secrets, or you do not have permission on any of the preference secrets.
          </li>
          <li>You can find the Authenticator Template ID manually by creating a new secret with the Authenticator
            template. The numeric ID is in the URL of the template.
          </li>
        </ul>
      </ul>
      <p>Autodiscover references found and loaded, almost done.</p>
      <p>In this situation the Autodiscover secrets were found and loaded. you can continue with the next step to setup
        your offline passphrase</p>
      <ul>
        <ul>
          <li>Press the Next step button to continue.</li>
        </ul>
      </ul>
      <p>User preferences found and loaded, no configuration remaining</p>
      <p>In this situation the user preferences secrets were found and loaded. This has loaded your previous set
        favorites, offline password and other application settings that may apply. you can continue to start using the
        app</p>
      <ul>
        <ul>
          <li>Press the "To authenticators" button to close the wizard.</li>
        </ul>
      </ul>
      <p>Offline Mode</p>
      <p>The offline mode step asks you for a passphrase. with this passphrase the app will encrypt all local storage as
        cache with 256 bit AES encryption. This will enable the offline mode and the option to store your settings,
        favorite and offline passphrase in secret server in a user preferences file.</p>
      <p>In the offline mode the 4PA Authenticator app can be used without an active internet connection. This is
        optional and requires that you to create an offline passphrase. This passphrase is used to encrypt your data
        locally.</p>
      <p>If disabled or not configured, your session is limited to 20 minutes and you will be logged out after
        expiration.</p>
      <p>Please note, whilst in offline mode it is not possible to retrieve new data without going online first.</p>
      <ul>
        <ul>
          <li>Provide an offline passphrase and press the "Enable offline mode". this completes the setup
            wizard.
          </li>
          <li>Optionally continue as an online-only session.</li>
        </ul>
      </ul>
      <hr/>
      <h3>Manual mode: login form</h3>
      <p>The manual mode login form shows the default login fields required.</p>
      <p>Use the remember me toggle to save these fields for next time usage.</p>
      <ul>
        <li>Secret Server URL (https://)</li>
      </ul>
      <ul>
        <li>Username</li>
      </ul>
      <ul>
        <li>Password</li>
      </ul>
      <ul>
        <li>User Domain</li>
      </ul>
      <ul>
        <li>One-time Password</li>
        <ul>
          <li>Leave empty, if your account does not have Two factor enabled.</li>
        </ul>
      </ul>
      <p>See or run for additional help and information the Setup wizard.</p>
      <hr/>
      <h3>Troubleshooting Failed login attempts</h3>
      <p>Be careful with trying to login too many times with an incorrect login attempt.</p>
      <p>An incorrect OTP also counts as an incorrect login.</p>
      <ul>
        <li>Always make sure you can login to Secret Server first without a problem.</li>
        <li>You can lock your account in Secret Server with too many login attempts.</li>
        <li>The One-time Password is valid only once within 30 seconds. If it was used in a failed login attempt it
          cannot be used again. please wait 30 seconds.
        </li>
        <li>Our advice is to Login to Secret Server manually after 2 or 3 failed attempts.</li>
        <li>IT can be you have a password change pending with Secret Server.</li>
        <li>IT can be you have a captcha challenge on the login from with secret server as a result of too many failed
          login attempts
        </li>
        <li>An OTP token can be out of sync in time.</li>
        <li>Make sure the time is correct and in sync with an NTP source on both the computer and the server.</li>
        <ul>
          <li>Alternatively you could wait for the token to switch on the 30 second mark and then login.</li>
        </ul>
      </ul>
      <hr/>
      <h2>Using the 4Passwords Authenticator</h2>
      <hr/>
      <h3>Authenticators</h3>
      <p>When you click on an authenticator it will copy the response code in the clip-board.</p>
      <p>You can set or unset an Authenticator as favorite by toggling the star icon.</p>
      <ul>
        <li>make sure to set an offline passphrase and save the settings in the online mode. in this way your favorites
          can be loaded in multiple sessions.
        </li>
      </ul>
      <ul>
        <li>you need to save the favorites and other settings manually by going to settings &gt; Save setting to
          server.
        </li>
      </ul>
      <hr/>
      <h3>Reload authenticators</h3>
      <p>This function will reload / refresh all Authenticator secrets you have permission to with the authenticators
        and its data from Secret Server.</p>
      <p>You need to be in the online mode to use this feature.</p>
      <hr/>
      <h3>Lock / Unlock mode</h3>
      <p>The lock icon will lock a session within the app or browser. you can unlock offline with your passphrase.</p>
      <hr/>
      <h3>Switch to Offline or Online mode</h3>
      <hr/>
      <h4>You're in encrypted offline mode</h4>
      <p>When you are in Offline mode, you will see a green bar in the top of the screen, this means you API access
        token from secret server is expired.</p>
      <ul>
        <li>click on the green bar or goto:</li>
        <ul>
          <li>Settings &gt; Encrypted offline mode.</li>
          <li>Login again for Online mode</li>
        </ul>
      </ul>
      <hr/>
      <h4>The Online mode</h4>
      <p>When in Online mode you can switch to offline mode</p>
      <ul>
        <li>goto: Settings &gt; Encrypted offline mode.</li>
        <li>activate: Switch to offline mode</li>
        <ul>
          <li>This will remove your Thycotic Secret Server API access token. you will need to login again if you want to
            refresh Authenticators, save or load settings
          </li>
        </ul>
      </ul>
      <hr/>
      <h3>Settings</h3>
      <hr/>
      <h4>Save to Server</h4>
      <p>You can save your user setting (favorites, settings and offline passphrase to secret server if you are in the
        online mode.</p>
      <hr/>
      <h4>Import from Server</h4>
      <p>You can load your user setting (favorites, settings and offline passphrase from secret server if you are in the
        online mode.</p>
      <hr/>
      <h4>Edit settings on Server</h4>
      <p>This will open the Thycotic Secret Server secret view of your user preferences secret. if you are in the online
        mode.</p>
      <hr/>
      <h2>ADMIN: Configure Thycotic Secret Server</h2>
      <p>Your System administrator should prepare Thycotic Secret Server in advance before usage. please make sure the
        following steps are taken.</p>
      <p>Secret Server Requirements</p>
      <ol>
        <li>Have the webservices Enabled (webservices API)</li>
        <ul>
          <li>From the Thycotic Interface go:</li>
          <li>Admin &gt; General &gt; Enable Webservices: Yes</li>
          <li>Default session timeout is 20 Minutes, this means that your online session will always be maximum 20
            minutes.
          </li>
          <li>Ip restriction can be applied on a Thycotic Secret Server users account, limiting the physical place or
            network users can connect to Secret server from the app. The IP restriction do not apply when users are
            working in the Offline mode.
          </li>
        </ul>
        <li>Have an 4PA compatible Authenticator Template</li>
        <ul>
          <li>The fastest way to get started is to import our template.<a
            href="https://4pa.app/templates/TSS-4PA-Authenticator-Template.txt"><br>Save the template</a></li>
          <ul>
            <li>From Secret Server as Admin go: Admin &gt; Secret Templates</li>
            <li>Paste the downloaded template in the "Import Secret Templates" section</li>
          </ul>
          <li>To manually create an Authenticator template:</li>
          <ul>
            <li>Give the Template a name starting with &ldquo;Authenticator&rdquo;</li>
            <li>Minimum we need is one field that contains the Authenticator code, with the name &ldquo;restorecode&rdquo;
              as password field.
            </li>
          </ul>
        </ul>
        <li>Create an Company wide auto discover preferences Secret. This will enable all users within a domain to use a
          specific Authenticator template from Secret Server.
        </li>
        <ul>
          <li>Create a secret from any web enabled Template from Secret Server.</li>
          <ul>
            <li>Give the Secret the
              name:<em>4pa_autodiscover_domain_preferences</em>
            </li>
            <ul>
              <li>where the domain word needs to be changed to is the actual domain name that a user will use in the
                domain field from login. If there are multiple variants to fill in the domain name then create several
                records with these names.
              </li>
              <li>This can also be the Thycotic alternate name or the word "local" for local account preferences.
                optionally it can also be left blank and made a global preference with "4pa_autodiscover_preferences".
              </li>
            </ul>
          </ul>
        </ul>
      </ol>
      <p>examples:<br><em>4pa_Autodiscover_mydomain_preferences<br> 4pa_Autodiscover_mydomain.corp_preferences
        <br>4pa_Autodiscover_local_preferences<br> 4pa_Autodiscover_preferences<br></em><em></em></p>
      <ul>
        <ul>
          <li>Add in the notes field a json object with the correct Authenticator Template ID for your
            domain.
          </li>
          <ul>
            <li>example: copy and paste the line below, and change the #### in the numeric Authenticator template
              Id<br><b>{"templateId":"####"}<br></b>
            </li>
            <ul>
              <li>Note: the template ID will be different on each secret server.</li>
              <li>To quickly retrieve your authenticator template id:</li>
              <ul>
                <li>view the ID in the URL header when you create a secret from Secret Server with the Authenticator
                  template.
                </li>
              </ul>
            </ul>
          </ul>
          <li>The other fields like a password, the URL or the username are ignored, but can be required fields in
            secret server.
          </li>
          <ul>
            <li>Add as user-id: 4pa_preferences</li>
            <li>Add as URL: the URL of your secret server</li>
            <li>generate a random password.</li>
          </ul>
          <li>Save the secret and share it with the correct scope and permissions so all targeted users can find this
            secret.
          </li>
        </ul>
      </ul>
      <hr/>
      <h2>Offline copy &amp; install</h2>
      <p>You can save this webpage offline and use it as a local app or host it inside your own organization
        internally.</p>
      <p>In future versions we will provide a Windows, OSX &amp; linux versions as a compiled app. this will be done
        with the Electron framework where other famous tools like Slack/Skype/Discord are made with.</p>
      <hr/>
      <h2>Feedback/support/bug reports</h2>
      <p>We would love to read your feedback on this application. Please contact us at support@4passwords.com.</p>
      <p></p>
    </div>
  </div>

</template>

<script>
  import EventHub from '../../events/event-hub';
  import {mapGetters} from 'vuex';

  export default {
    name: 'help',
    data() {
      return {
        active: false,
      };
    },
    computed: {
      ...mapGetters({
        loggedin: 'auth/loggedin',
      })
    },
    methods: {
      hide() {
        this.active = false;
      },
      show() {
        this.active = true;
      }
    },
    mounted() {
      EventHub.$on('help-show', this.show);
    },
    beforeDestroy() {
      EventHub.$off('help-show');
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/pages/Help.vue